import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { routes } from "consts";
import React from "react";

import { useNavigate } from "react-router-dom";
import { UserForm, UserFormValues } from "./UserForm/UserForm";
import { useToaster } from "utils";
import { studentsApi } from "api/studentsApi";

export const AddUserPage = () => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();

  const breadcrumbs = [{ title: "Użytkownicy", path: routes.STUDENTS }, { title: "Dodawanie użytkownika" }];

  const onSubmit = async (data: UserFormValues) => {
    try {
      await studentsApi.create(data);
      navigate(routes.STUDENTS);
      showSuccess("Użytkownik został dodany.");
    } catch (e) {
      console.error(e);
      showError("Nie udało się dodać użytkownika.");
    }
  };

  return (
    <PageMain>
      <HeaderWithBreadcrumbs breadcrumbs={breadcrumbs} headerText="Dodaj użytkownika" />
      <UserForm onSubmit={onSubmit} />
    </PageMain>
  );
};
